<script setup lang="ts">
import { FdxButton, FdxDrawer, FdxModal } from '@foodics/ui-common';
import Authorized from './Authorized.vue';
import type { Permission } from '@/types/models';
import { ref } from 'vue';
import { useViewport } from '@/composables/viewport';

defineProps<{
    permissions?: Permission['name'][];
}>();

const isOpen = ref(false);
const { isMobileView } = useViewport();
</script>

<template>
    <Authorized v-if="permissions" :permissions="permissions" match="any">
        <slot />
        <template #unauthorized>
            <button
                class="items-center flex gap-x-3 rounded-lg transition-colors w-full"
                @click="isOpen = true"
            >
                <div class="pointer-events-none">
                    <slot />
                </div>

                <span class="ms-auto">
                    <FdxIconLockOutline class="size-6 text-gray-500" />
                </span>
            </button>

            <component
                :is="isMobileView ? FdxDrawer : FdxModal"
                v-model="isOpen"
                :placement="isMobileView ? 'bottom' : 'end'"
                :class="isMobileView ? 'rounded-t-lg' : 'w-[440px]'"
            >
                <div
                    class="size-20 rounded-full bg-gray-200 flex items-center justify-center mx-auto mb-6"
                >
                    <FdxIconLockOutline class="size-6 text-gray-1000" />
                </div>
                <h3 class="text-title-3 font-bold">
                    {{ $t('generic.authorization.unauthorized.title') }}
                </h3>
                <p class="text-body">
                    {{ $t('generic.authorization.unauthorized.message_full') }}
                </p>

                <template #footer>
                    <div class="flex justify-end">
                        <FdxButton @click="isOpen = false">
                            {{ $t('generic.common_terms.got_it') }}
                        </FdxButton>
                    </div>
                </template>
            </component>
        </template>
    </Authorized>

    <div v-else>
        <slot />
    </div>
</template>

<style scoped>
:deep(.fdx-dialog__header) {
    @apply hidden;
}
</style>
